import { useLanguage } from "../i18n/LanguageContext";

export const VideoSection = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-white pb-20 pt-4 lg:pb-24" data-testid="video-section">
      <div className="mx-auto max-w-[1100px] px-4 sm:px-6 lg:px-8">
        <h2
          className="font-display text-center text-3xl font-bold tracking-tight text-[#0d2b52] sm:text-4xl"
          data-testid="video-title"
        >
          {t.video.title}
        </h2>
        <div className="mt-10 border border-[#e2e8f0]">
          <video
            controls
            preload="metadata"
            playsInline
            className="h-auto w-full"
            data-testid="video-player"
          >
            <source src="/assets/uba-presentation.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </section>
  );
};
